import { useCallback } from 'react';

declare global {
  interface Window {
    showJiraCollector?: () => void;
  }
}

export const useJiraCollector = () => {
  const showCollector = useCallback(() => {
    if (window.showJiraCollector) {
      window.showJiraCollector();
    } else {
      console.warn('Jira collector not loaded yet');
    }
  }, []);

  return { showCollector };
};
